import { dateBackendToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import type Value from 'modules/custom_resources/store/models/customResources/Value'
import type Employee from 'modules/employees/store/models/Employee'

const NOT_AVAILABLE = '-'
interface Props {
  schema: Schema | undefined
  field: Field
  employee?: Employee
  currentValue?: Value
  notAvailable?: string
  companyLocale: string
}

export const getValue = ({
  schema,
  field,
  currentValue,
  employee,
  notAvailable = NOT_AVAILABLE,
  companyLocale,
}: Props): string => {
  if (!currentValue || !currentValue.has(String(field.attributes.id))) {
    return notAvailable
  }

  const value = currentValue?.attributes[String(field.attributes.id)]

  if (!value) return notAvailable

  if (
    schema?.attributes.effective_at_id === field.attributes.id ||
    field.attributes.field_type === FieldTypes.date
  ) {
    return dateBackendToUI(String(value))
  }

  if (field.attributes.field_type === FieldTypes.multipleChoice) {
    const options: string[] = field.attributes.options
    const values = options.filter((item) => String(value).includes(item))

    return values.join(', ')
  }

  if (field.attributes.field_type === FieldTypes.checkbox) {
    return !value ? i18n.t('custom_resources.basic.no') : i18n.t('custom_resources.basic.yes')
  }

  if (field.attributes.field_type === FieldTypes.cents) {
    return (Number(value) / 100).toString()
  }

  if (field.attributes.field_type === FieldTypes.money) {
    const currency = employee?.attributes.legal_entity_currency
    return MoneyWithCurrency({
      amount: Number(value),
      currency,
      locale: companyLocale,
    })
  }

  return value
}
